import {useTranslations} from "react-ui";
import React from "react";

export interface CloseMobileDialogFooterButtonProps {
    onClick: () => void;
    label?: string;
}

export const CloseMobileDialogFooterButton: React.FC<CloseMobileDialogFooterButtonProps> = ({onClick, label} ) => {
    const {translated} = useTranslations();
    return <button className={"w-full bg-white text-balloon border-balloon border hover:bg-balloon hover:text-white rounded-full p-2"} onClick={onClick}>{translated(label || 'close', 'Close')}</button>
}